import React, { useEffect } from 'react';
import { useDistrictContext } from 'src/contexts/district.context';
import { actionTypes } from 'src/ducks/district.duck';
import { getDistrictStatus } from 'src/selectors/district.selector';
import DistrictListView from './district-list.view';

const DistrictView: React.FC = () => {
  const { state, actions } = useDistrictContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <DistrictListView
      loading={
        getDistrictStatus(state, actionTypes.DISTRICT_LIST_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default DistrictView;
